import React, { useState, useEffect } from "react";

import PanelSection from "./PanelSection/PanelSection";
import PanelItem from "./PanelItem/PanelItem";
import classes from "./NavigationPanel.css"

const NavigationPanel = (props) => {
  const [deployDate, setDeployDate] = useState(null);

  useEffect(() => {
    fetch('/deploy-date.txt')
      .then(response => {
        if (!response.ok) throw new Error('Not found');
        return response.text();
      })
      .then(date => {
        const trimmed = date.trim();
        // Validate format: should be like "2026.01.12" or "dev"
        if (trimmed === 'dev' || /^\d{4}\.\d{2}\.\d{2}$/.test(trimmed)) {
          setDeployDate(trimmed);
        }
      })
      .catch(() => setDeployDate(null));
  }, []);

  return (
    <div className={classes.container}>

      <div className={classes.subcontainer}>
        {props.enableAdministation &&
        <PanelSection title="Administratief" normallyOpen={window.location.pathname.startsWith("/administration")}>
          <PanelItem label="Klanten" page="/administration/customers"/>
          <PanelItem label="Verkopen" page="/administration/sales"/>
          <PanelItem label="Aankopen" page="/administration/purchases"/>
          <PanelItem label="Boekingen" page="/administration/bookings"/>
          <PanelItem label="Financieel" page="/administration/financial"/>
          <PanelItem label="Uitbetaling" page="/administration/cashout"/>
        </PanelSection>}

        {props.enableSales &&
        <PanelSection title="Sales dashboard" normallyOpen={window.location.pathname.startsWith("/sales")}>
          <PanelItem label="Overview" page="/sales/overview"/>
          <PanelItem label="Bestellingen" page="/sales/orders"/>
          <PanelItem label="Deals" page="/sales/deals"/>
        </PanelSection>}

        {props.enableStock &&
        <PanelSection title="Stockbeheer" normallyOpen={window.location.pathname.startsWith("/stock")}>
          <PanelItem label="Overzicht" page="/stock/overview"/>
          <PanelItem label="Boekingen" page="/stock/bookings"/>
          <PanelItem label="Parts catalog" page="/stock/catalog"/>
          <PanelItem label="Parts in use" page="/stock/in-use"/>
        </PanelSection>}

        {props.enableDeployments &&
        <PanelSection title="Deployments" normallyOpen={window.location.pathname.startsWith("/deployments")}>
          <PanelItem label="Gateways" page="/deployments/edit"/>
          <PanelItem label="Licenses" page="/deployments/licenses"/>
          <PanelItem label="Usage statistics" page="/deployments/statistics"/>
        </PanelSection>}

        {props.enableInfrastructure &&
        <PanelSection title="Infrastructure" normallyOpen>
          <PanelItem label="Server status" page="/infrastructure/server"/>
          <PanelItem label="Download pages" page="/infrastructure/downloads"/>
          <PanelItem label="Decoder software" page="/infrastructure/decoders"/>
          <PanelItem label="Software images" page="/infrastructure/images"/>
        </PanelSection>}

        {props.enablePlatforms &&
        <PanelSection title="Platforms" normallyOpen={window.location.pathname.startsWith("/platforms")}>
          <PanelItem label="Accounts" page="/platforms/accounts"/>
          <PanelItem label="Companies" page="/platforms/companies"/>
          {props.enableDeviceLogistics && (
            <PanelItem label="Devices" page="/platforms/devices"/>
          )}
          <PanelItem label="Shop" page="/platforms/shop"/>
        </PanelSection>}
      </div>

      {deployDate && (
        <p className={classes.versionNumber}>
          Version {deployDate}
        </p>
      )}
    </div>
  );
}

export default NavigationPanel;
